import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getArticleById } from '../lib/getArticle';
import { Article } from '../types/article';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {formatDateTime} from "../utils/utils";

export default function PostDetail() {
    const { id } = useParams<{ id: string }>();
    const [article, setArticle] = useState<Article | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!id) return;
        (async () => {
            setLoading(true);
            const data = await getArticleById(id);
            setArticle(data);
            setLoading(false);
        })();
    }, [id]);

    if (loading) return <p>読み込み中…</p>;
    if (!article) return <p>記事が見つかりませんでした。</p>;

    return (
        <article style={{ maxWidth: 800, margin: '0 auto', padding: '2rem' }}>
            <Link to="/">← 一覧へ</Link>
            <h1>{article.title}</h1>
            <small style={{ color: '#666' }}>
                作成: {formatDateTime(article.createdAt)}
                {article.updatedAt ? ` / 更新: ${new Date(article.updatedAt).toLocaleString('ja-JP')}` : ''}
            </small>
            <div style={{ marginTop: 16 }} className="markdown-body">
                {/* ReactMarkdown provides built-in XSS protection by not rendering dangerous HTML by default.
                    For additional security with untrusted content, consider implementing a Content Security Policy. */}
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{article.content}</ReactMarkdown>
            </div>
        </article>
    );
}
